module.exports = __webpack_public_path__ + "img/app-haose.3b7bcedf.png";